import { Injector, Pipe, PipeTransform } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';

@Pipe({
  name: 'thousands'
})
export class ThousandsPipe extends AppComponentBase implements PipeTransform {

  constructor(injector: Injector) {
    super(injector);
  }

  public transform(value: any) {
    return value.toString().toLocaleString('en').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

}
